(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("_DRAGON_COMPONENTS", [], factory);
	else if(typeof exports === 'object')
		exports["_DRAGON_COMPONENTS"] = factory();
	else
		root["_DRAGON_COMPONENTS"] = root["_DRAGON_COMPONENTS"] || {}, root["_DRAGON_COMPONENTS"]["index"] = factory();
})(this, () => {
return 